import * as React from 'react'
import Box from '@mui/material/Box'
import TextField from '@mui/material/TextField'
import InputAdornment from '@mui/material/InputAdornment'
import IconButton from '@mui/material/IconButton'
import Visibility from '@mui/icons-material/Visibility'
import VisibilityOff from '@mui/icons-material/VisibilityOff'
import { useIntl } from 'react-intl'

interface Props {
    name?: string
    label?: string
    error?: boolean
    disabled?: boolean
    required?: boolean
    value?: string
    onChange: (event: any) => void
    placeholder?: string
    type?: string
}

const FTLoginInput: React.FC<Props> = ({
    name,
    label,
    error,
    disabled,
    required,
    value,
    type,
    onChange,
}) => {
    const [showPassword, setShowPassword] = React.useState(false)
    const intl = useIntl()
    const translatedLabel = label ? intl.formatMessage({ id: label }) : undefined

    const isPassword = type === 'password'
    const effectiveType = isPassword ? (showPassword ? 'text' : 'password') : type

    return (
        <Box sx={{ width: '100%', my: 2 }}>
            <TextField
                id={name}
                name={name}
                label={translatedLabel}
                value={value}
                onChange={onChange}
                error={!!error}
                disabled={disabled}
                required={required}
                type={effectiveType}
                variant="standard"
                fullWidth
                autoComplete="off"
                InputLabelProps={{ sx: { fontWeight: 500, color: 'text.secondary' } }}
                InputProps={{
                    endAdornment: isPassword ? (
                        <InputAdornment position="end">
                            <IconButton
                                aria-label="toggle password visibility"
                                onClick={() => setShowPassword((prev) => !prev)}
                                edge="end"
                                size="small"
                            >
                                {showPassword ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                        </InputAdornment>
                    ) : undefined,
                }}
            />
        </Box>
    )
}

export default FTLoginInput